export default '6.39.1';